import { call, put, select } from 'redux-saga/effects';
import { signalingPollResultsShared } from 'features/polls/actions';
import { Action } from '@reduxjs/toolkit';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import i18n from 'i18n';
import { selectSidePanel, sidePanelOpened } from 'features/side-panels/sidePanelsSlice';
import { FeatureFlag } from 'features/feature-set/types';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { SidePanelType } from 'features/side-panels/types';
import { resolveEventUserSaga } from 'features/users/utils/resolveEventUser';
import { User } from 'features/users/types';
import { EventUser } from 'services/signaling';

export function* onPollResultsSharedSaga(action: ReturnType<typeof signalingPollResultsShared>) {
  const canTakePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.takePolls);
  const canModeratePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.managePolls);

  if (!canTakePolls || canModeratePolls) {
    return;
  }

  const openedPanel: SidePanelType = yield select(selectSidePanel);
  if (openedPanel === 'polls') {
    // show only if the polls panel is not opened
    return;
  }

  const { initiator, data } = action.payload;
  const resolvedInitiator: User | EventUser | undefined = yield call(
    resolveEventUserSaga,
    initiator
  );
  const initiatorName = resolvedInitiator?.name;

  const actionNotificationThunk: Action = yield call(
    addActionNotification,
    {
      content: i18n.t('notifications:polls.results_shared.content', {
        username: initiatorName,
      }),
      okText: i18n.t('notifications:polls.results_shared.btn_ok_label'),
      okAction: sidePanelOpened('polls'),
      initiator: resolvedInitiator,
      scope: [FeatureFlag.polls],
    },
    {
      toastId: `poll_results_shared_${data.id}`,
    }
  );

  yield put(actionNotificationThunk);
}
